export const getAdvancedChartVisible = state => state.advancedChartVisible;
